import ImageCTA from "@components/Image/ImageCTA";
import { Link } from "@components/Link/Link";
import React from "react";

import { clsx } from "clsx";

import { withFeaturedArticleCard } from "./withFeaturedArticleCard";

const Wrapper = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "flex w-1/2 flex-col p-micro sm:p-mini lg:w-1/4",
    )}
  />
);

const ImageWrapper = (props: any) => (
  <div {...props} className={clsx(props.className, "w-full")} />
);

const ContentWrapper = (props: any) => (
  <div {...props} className={clsx(props.className, "flex flex-1 flex-col")} />
);

const Content = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "flex-1 focus-visible:!outline-offset-[-1px]",
    )}
  />
);

const Title = (props: any) => (
  <p
    {...props}
    className={clsx(
      props.className,
      "my-micro block font-display text-[1.5rem] leading-[2rem] md:my-mini md:font-medium",
    )}
  />
);

const Summary = (props: any) => (
  <p
    {...props}
    className={clsx(
      props.className,
      "hidden text-body leading-body opacity-70 md:block",
    )}
  />
);

const StyledLink = (props: any) => (
  <Link
    {...props}
    className={clsx(
      props.className,
      "flex-none text-caption leading-caption hover:text-warning sm:text-body md:hidden",
    )}
  />
);

const FeaturedArticleCard = withFeaturedArticleCard(
  ({ title, image, summary, link }) => {
    return (
      <Wrapper>
        <ImageWrapper>
          <ImageCTA
            sanityImage={image}
            buttonText="Read more"
            buttonLink={link}
            alt={image?.alt || ""}
            blog={true}
          />
        </ImageWrapper>
        <ContentWrapper>
          <Content>
            {title && (
              <Link to={link}>
                <Title>{title}</Title>
              </Link>
            )}
            {summary && <Summary>{summary}</Summary>}
          </Content>
          {title && (
            <StyledLink className="underlined-black" to={link}>
              <span>Read more</span>
            </StyledLink>
          )}
        </ContentWrapper>
      </Wrapper>
    );
  },
);

export default FeaturedArticleCard;
